<template>
  <div
    class="flex flex-col md:flex-row items-center md:items-stretch w-full text-white rounded-lg shadow-md overflow-hidden ring-1 ring-white tracking-wider"
  >
    <!-- Logo e lutadores -->
    <div
      class="flex flex-col justify-between md:flex-row md:items-center w-full md:w-[65%] p-4"
    >
      <!-- Logo -->
      <div class="md:flex md:justify-center mb-4 my-auto w-full h-full hidden">
        <img
          :src="
            appLogo
          "
          alt="CombateOne"
          class="w-1/2 h-1/2 my-auto"
        />
      </div>

      <!-- banner -->
      <div class="w-full">
        <div class="flex justify-center items-center gap-2">
          <img
            :src="image"
            alt="Lutador 1"
            class="h-36 md:h-56 object-contain"
            width="300"
            height="144"
          />
        </div>
      </div>
    </div>

    <!-- Detalhes e botão -->
    <div
      class="flex flex-col justify-center md:justify-between text-center md:text-left w-full md:w-[35%] p-4 border-t md:border-t-0 md:border-l border-gray-200"
    >
      <div class="mb-4">
        <h3 class="text-2xl font-bold text-white uppercase">
          {{ title }}
        </h3>
        <p class="text-base text-white font-semibold tracking-widest">
          {{ tag }}
        </p>
        <!-- <p class="text-xs text-gray-500 font-inter tracking-normal mt-2">
          {{ date }}
        </p> -->
        <p class="text-xs text-gray-500 font-inter tracking-normal mt-2">
          {{ desc }}
        </p>
      </div>

      <!-- Botão -->
      <slot />
    </div>
  </div>
</template>

<script setup>
import { dataShared } from '@/shared/store'
import { computed } from 'vue'

const appLogo = computed(() => dataShared.getters.getAppLogo)
const isMobile = computed(() => window.innerWidth < 1030)
const props = defineProps({
  image: {
    type: String,
    required: false
  },
  title: {
    type: String,
    default: 'X Solution'
  },
  date: {
    type: String,
    default: ''
  },
  amount: {
    type: Boolean,
    default: false
  },
  tag: {
    type: String,
    required: false
  },
  desc: {
    type: String,
    required: false
  }
})
</script>
